export default "__VITE_ASSET__0K30BA5f__"